import React, { useRef } from 'react'
import { useLocation } from '@reach/router'
import { useInView } from 'framer-motion'

import { Container } from '../../Container'
import ContentfulLongText from '../../ContentfulLongText'
import { GlobalIframe } from '../../GlobalComponent';

export const ContentfulMediaTextBlock = ({ index, item }) => {
    const location = useLocation()
    const isCustom = location.pathname === '/mobile-app/'

    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    return (
        <div key={index} ref={ref} className='block bg-frost-white py-40 px-32 bg-white'>
            <Container isTight={isCustom ? true:false}>
                <div className='grid col-2 col-1-md col-1-sm gap-40 align-center'>
                    <div className='block' style={{ 
                    transform: isInView ? "none" : "translateX(-200px)", 
                    opacity: isInView ? 1 : 0, 
                    transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"}}>
                        {item.isMediaTextBlockNameVisible && <h2 className='family-sans-bold text-4xl'>{item.mediaTextBlockName}</h2>}
                        <ContentfulLongText longTextContent={item.mediaTextBlockDescription.mediaTextBlockDescription} classNameProp='text--dark' />
                    </div>
                    {item.mediaTextBlockYoutubeLink ? (
                        <div className='block' style={{ 
                            transform: isInView ? "none" : "translateX(2000px)", 
                            opacity: isInView ? 1 : 0, 
                            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"}}>
                            <GlobalIframe className='w-full h-120' link={item.mediaTextBlockYoutubeLink} title={'We Are Savor Brands'} />
                        </div>
                    ):(
                        <div className='block' style={{ 
                            transform: isInView ? "none" : "translateX(2000px)", 
                            opacity: isInView ? 1 : 0, 
                            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"}}>
                            <img src={item.mediaTextBlockImages[0].gatsbyImageData.images.fallback.src} className={`${!isCustom ? 'w-full h-120':''}`} alt={item.mediaTextBlockName} />
                        </div>
                    )}
                </div>
            </Container>
        </div>
    )
}